import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { usePanoramaMethodLogger } from '@wix/cli-panorama';
import { BlocksServicesClient } from './blocks-services-client.js';

export function useBlocksServicesClient() {
  const httpClient = useHttpClient({ type: 'api' });
  const client = useMemo(
    () => new BlocksServicesClient(httpClient),
    [httpClient]
  );

  return usePanoramaMethodLogger(client);
}
